import { useState } from "react";
import { ChevronDown, CheckCircle2, Bookmark, Star, Printer } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { Medal } from "@/components/badges/Medal";

export const StudentRow = ({ s, onPrint, printing }) => {
  const [open, setOpen] = useState(false);
  const { t, lang } = useLang();
  const tt = t.teacher;
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(lang, { day: "numeric", month: "short", year: "numeric" }) : "—");
  return (
    <div className="border-t border-[#E5DCCB]" data-testid={`teacher-student-row-${s.id}`}>
      <div className="flex items-center">
      <button onClick={() => setOpen(!open)} className="flex-1 min-w-0 grid grid-cols-2 md:grid-cols-[2fr_1fr_1fr_1fr_1fr_auto] gap-3 items-center px-4 py-4 text-start hover:bg-[#FAF7F2] transition-colors" data-testid={`teacher-student-toggle-${s.id}`}>
        <span>
          <span className="font-semibold flex flex-wrap items-center gap-1.5">
            {s.name}
            <span className="inline-flex items-center gap-0.5 text-xs font-bold text-amber-800" data-testid={`teacher-student-stars-${s.id}`}><Star className="w-3.5 h-3.5 fill-[#F59E0B] text-[#F59E0B]" />{s.stars ?? 0}</span>
            {Array.from({ length: s.badge_level ?? 0 }, (_, i) => <span key={i} title={t.badges.names[i]}><Medal i={i} size={20} testId={`teacher-student-medal-${s.id}-${i}`} /></span>)}
          </span>
          <span className="text-xs text-stone-600" dir="ltr" data-testid={`teacher-student-username-${s.id}`}>{s.username || s.email}</span>
        </span>
        <span className="text-sm">{t.lib.level} {s.level}</span>
        <span className="text-sm text-emerald-800 font-semibold" data-testid={`teacher-student-finished-${s.id}`}>{tt.finishedN(s.finished)}</span>
        <span className="text-sm text-amber-800">{tt.progressN(s.in_progress)}</span>
        <span className="text-xs text-stone-600">{tt.lastActivity}: {fmt(s.last_activity)}</span>
        <ChevronDown className={`w-4 h-4 justify-self-end transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      <button onClick={() => onPrint?.(s)} disabled={printing} title={tt.printCard} aria-label={tt.printCard} data-testid={`teacher-print-card-${s.id}`}
        className="shrink-0 me-3 inline-flex items-center gap-1.5 rounded-full border border-[#047857] text-[#047857] px-3 py-2 text-xs font-semibold hover:bg-[#047857] hover:text-white transition-colors disabled:opacity-50">
        <Printer className="w-4 h-4" /> <span className="hidden lg:inline">{tt.printCard}</span>
      </button>
      </div>
      {open && (
        <div className="px-4 pb-5 bg-[#FAF7F2]">
          {!s.books?.length ? <p className="text-sm text-stone-600 py-3">{tt.noBooks}</p> : (
            <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 pt-3">
              {s.books.map((b) => (
                <li key={b.book_id} className="bg-white border border-[#E5DCCB] p-4" data-testid={`teacher-student-book-${s.id}-${b.book_id}`}>
                  <p className="font-semibold" dir="auto">{b.title}</p>
                  <p className="text-xs text-stone-600 mt-1">{t.subjects[b.subject]?.name} · {t.lib.level} {b.level}</p>
                  <div className="mt-3 flex items-center justify-between text-xs">
                    {b.finished
                      ? <span className="inline-flex items-center gap-1 text-emerald-800 font-bold"><CheckCircle2 className="w-3.5 h-3.5" /> {t.lib.finished}</span>
                      : <span className="inline-flex items-center gap-1 text-amber-800 font-bold"><Bookmark className="w-3.5 h-3.5" /> {t.lib.pageOf(b.page + 1, b.page_count)}</span>}
                    <span className="text-stone-600">{fmt(b.updated_at)}</span>
                  </div>
                  <div className="mt-2 h-1 bg-[#E5DCCB] rounded-full overflow-hidden">
                    <div className={`h-full ${b.finished ? "bg-[#047857]" : "bg-[#B45309]"}`} style={{ width: `${b.finished ? 100 : ((b.page + 1) / b.page_count) * 100}%` }} />
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
};
